export const deserializeAncestors = (ancestors = [], platform) =>
  ancestors.map(a => ({
    id: a.id,
    ...(a.platforms &&
      a.platforms[platform] && { name: a.platforms[platform].name }),
  }));
